import script from "./TripleChoixMetier.vue?vue&type=script&setup=true&lang=js"
export * from "./TripleChoixMetier.vue?vue&type=script&setup=true&lang=js"

import "./TripleChoixMetier.vue?vue&type=style&index=0&id=437f9c44&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437f9c44"]])

export default __exports__